import * as React from 'react';
import { withStyles, Theme, createStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Button, CircularProgress, Select, MenuItem, InputLabel, FormControl, TextField } from '@material-ui/core';
import strings from 'src/strings';
import { WithToast, withToast } from '../HOC/Toast';
import { WithUser, withUser } from '../HOC/User';
import { Package, PaymentsAPI, APIError, APIErrorType } from 'src/api';
import { RouteComponentProps, withRouter } from 'react-router';
import KDGlobal from '../Global';
import { Coupon } from 'src/api/endpoints/payments';


interface ReviewProps {
    onNext: () => void
    onBack: () => void
    onCancel: () => void
}
interface ReviewState {
    loading: boolean
    selected_product?: string;
    selected_plan?: string;
    coupon?: string;
    api_coupon?: Coupon
    coupon_valid: boolean;
    packages: Package[]
    upgrading: boolean,
    card?: {
        brand: string;
        last4: string;
        name: string;
        exp: string;
    }
}
class Review extends React.Component<WithStyles<typeof styles> & ReviewProps & RouteComponentProps<{}, {}, { tier: string, upgrade: boolean }> & WithToast & WithUser<true>, ReviewState> {

    constructor(props: WithStyles<typeof styles> & ReviewProps & WithToast & RouteComponentProps<{}, {}, { tier: string, upgrade: boolean }> & WithUser<true>) {
        super(props)
        this.state = {
            loading: false,
            coupon_valid: true,
            packages: [],
            selected_product: this.props.location.state ? this.props.location.state.tier : undefined,
            upgrading: this.props.location.state ? this.props.location.state.upgrade : false
        }
        this.validateCoupon = this.validateCoupon.bind(this);
    }

    private isCurrentPlan(planId: string) {
        return this.props.user && this.props.user.hasValidSubscription() && this.props.user.getValidSubscription()!.package.id == planId
    }

    private isDowngrade(plan: Package) {
        if (this.props.user && this.props.user.hasValidSubscription()) {
            return this.props.user!.getValidSubscription()!.package.num_clients > plan.num_clients;
        }
        return false
    }

    componentDidMount() {
        this.setState({ loading: true })
        PaymentsAPI.getPackages().then(packages => {
            let current_interval: string | undefined = undefined
            if (this.props.user && this.props.user.hasValidSubscription()) {
                let current_package = packages.find(t => t.id == this.props.user.getValidSubscription()!.package.id)
                if (current_package) {
                    let plan = current_package.pricing_infos.find(i => i.id == this.props.user.getValidSubscription()!.plan_id)
                    if (plan) {
                        current_interval = plan.interval
                    }
                }
            }
            this.setState({
                loading: !this.state.card, packages: packages.sort((it1, it2) => {
                    return it1.order - it2.order
                }).map(it => {
                    it.pricing_infos = it.pricing_infos.sort((it1, it2) => {
                        return it2.interval.localeCompare(it1.interval)
                    }).filter(t => {
                        if (current_interval) {
                            //return t.interval == current_interval
                        }
                        return true
                    })
                    return it
                }).filter(t => {
                    if (this.isDowngrade(t) || this.isCurrentPlan(t.id)) {
                        return false;
                    }
                    return true;
                })
            })
        }).catch(() => {
            this.props.showToast('error', strings.error_generic);
            this.setState({ loading: false });
        })
        PaymentsAPI.getCreditCard().then(card => {
            this.setState({ card, loading: !this.state.packages.length })
        }).catch(() => {
            this.props.showToast('error', strings.error_noCreditCard);
            this.setState({ loading: false });
        })
    }

    private validateCoupon() {
        if (this.state.coupon && this.state.coupon.trim() != '') {
            this.setState({ loading: true })
            PaymentsAPI.getCoupon(this.state.coupon).then(cp => {
                this.setState({ loading: false, coupon_valid: true, api_coupon: cp })
            }).catch(err => {
                this.setState({ loading: false, coupon_valid: false, api_coupon: undefined })
            })
        } else {
            this.setState({ coupon: undefined, coupon_valid: true, api_coupon: undefined })
        }
    }

    private submit() {
        if (this.state.selected_plan && this.state.selected_product && this.state.card) {
            this.setState({ loading: true })
            if (this.state.upgrading) {
                PaymentsAPI.upgrade(this.state.packages.find(p => p.id == this.state.selected_product)!, this.state.selected_plan, this.state.api_coupon ? this.state.coupon : undefined).then(user => {
                    KDGlobal.instance.setUser(user);
                    this.setState({ loading: false })
                    this.props.onNext()
                }).catch((err: APIError) => {
                    if (err.type == APIErrorType.NotAccessibleError) {
                        this.props.showToast('error', strings.checkout_errorSubscriptionAlreadyExisting)
                    } else {
                        this.props.showToast('error', strings.error_generic)
                    }
                    this.setState({ loading: false })
                })
            } else {
                PaymentsAPI.subscribe(this.state.packages.find(p => p.id == this.state.selected_product)!, this.state.selected_plan, this.state.api_coupon ? this.state.coupon : undefined).then(user => {
                    KDGlobal.instance.setUser(user);
                    this.setState({ loading: false })
                    this.props.onNext()
                }).catch((err: APIError) => {
                    if (err.type == APIErrorType.NotAccessibleError) {
                        this.props.showToast('error', strings.checkout_errorSubscriptionAlreadyExisting)
                    } else {
                        this.props.showToast('error', strings.error_generic)
                    }
                    this.setState({ loading: false })
                })
            }
        } else {
            this.props.showToast('error', strings.checkout_errrorPleaseSelectPlanAndProduct)
        }
    }

    private back() {
        this.props.onBack()
    }


    public render() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    {strings.checkout_subscribe}
                </Typography>
                <Grid container spacing={8}>
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="ip-package">{strings.checkout_package}</InputLabel>
                            <Select
                                value={this.state.selected_product || ''}
                                onChange={(e) => this.setState({ selected_product: e.target.value as string, selected_plan: undefined })}
                                inputProps={{ name: 'ip-package' }}>
                                {this.state.packages.map(product => {
                                    return <MenuItem key={product.id} value={product.id}>{product.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        {this.state.selected_product && this.state.packages.find(p => p.id == this.state.selected_product) &&
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="ip-plan">{strings.checkout_interval}</InputLabel>
                                <Select
                                    value={this.state.selected_plan || ''}
                                    onChange={(e) => this.setState({ selected_plan: e.target.value as string })}
                                    inputProps={{ name: 'ip-plan' }}>
                                    {this.state.packages.find(p => p.id == this.state.selected_product)!.pricing_infos.map(info => {
                                        return <MenuItem key={info.id} value={info.id}>${(info.amount / 100).toFixed(2)}/{info.interval}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>}
                    </Grid>
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id="coupon"
                                name="coupon"
                                label={strings.checkout_coupon}
                                error={!this.state.coupon_valid}
                                fullWidth
                                value={this.state.coupon}
                                onBlur={this.validateCoupon}
                                onChange={(e) => this.setState({ coupon: e.target.value, api_coupon: undefined })} />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    {this.state.selected_plan && this.state.selected_product && this.state.packages.find(p => p.id == this.state.selected_product) && <Grid item xs={12} sm={6}>
                        <Typography variant="h6" gutterBottom className={classes.title}>
                            {strings.checkout_pricing}
                        </Typography>
                        {this.state.api_coupon && <>
                            {this.state.api_coupon.amount_off && <Typography gutterBottom>Amount off: ${this.state.api_coupon.amount_off / 100}</Typography>}
                            {this.state.api_coupon.percent_off && <Typography gutterBottom>Percent off: {this.state.api_coupon.percent_off}</Typography>}
                            <Typography gutterBottom>Coupon Duration: {this.state.api_coupon.duration == 'forever' ? 'Forever' : this.state.api_coupon.duration == 'once' ? 'Once' : (this.state.api_coupon.duration_in_months + ' Months')}</Typography>
                        </>}
                        <Typography gutterBottom>{this.state.packages.find(p => p.id == this.state.selected_product)!.name}</Typography>
                        <Typography gutterBottom>{this.state.api_coupon && 'Original Price: '}${this.state.packages.find(p => p.id == this.state.selected_product)!.pricing_infos.find(i => i.id == this.state.selected_plan)!.amount / 100}/{this.state.packages.find(p => p.id == this.state.selected_product)!.pricing_infos.find(i => i.id == this.state.selected_plan)!.interval}</Typography>
                        {this.state.packages.find(p => p.id == this.state.selected_product)!.pricing_infos.find(i => i.id == this.state.selected_plan)!.trial != undefined && <Typography gutterBottom>Trial days: {this.state.packages.find(p => p.id == this.state.selected_product)!.pricing_infos.find(i => i.id == this.state.selected_plan)!.trial}</Typography>}
                    </Grid>}
                    {this.state.card && <Grid item container direction="column" xs={12} sm={6}>
                        <Typography variant="h6" gutterBottom className={classes.title}>
                            {strings.checkout_paymentMethod}
                        </Typography>
                        <Grid container>
                            <React.Fragment>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{strings.checkout_cardType}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{this.state.card.brand}</Typography>
                                </Grid>
                            </React.Fragment>
                            <React.Fragment>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{strings.checkout_cardHolder}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{this.state.card.name}</Typography>
                                </Grid>
                            </React.Fragment>
                            <React.Fragment>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{strings.checkout_cardNumber}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>xxxx-xxxx-xxxx-{this.state.card.last4}</Typography>
                                </Grid>
                            </React.Fragment>
                            <React.Fragment>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{strings.checkout_cardExp}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>{this.state.card.exp}</Typography>
                                </Grid>
                            </React.Fragment>
                        </Grid>
                    </Grid>}

                </Grid>

                <div className={classes.buttons}>
                    <Button
                        variant='outlined'
                        color="secondary"
                        onClick={this.props.onCancel.bind(this)}
                        disabled={this.state.loading}
                        className={this.props.classes.button + ' ' + this.props.classes.cancel_button}>
                        {strings.cancel}
                    </Button>
                    {this.state.loading && <CircularProgress size={30} className={this.props.classes.button} />}
                    <Button onClick={this.back.bind(this)} className={classes.button} disabled={this.state.loading}>
                        {strings.back}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={this.state.loading || !(this.state.selected_plan && this.state.selected_product && this.state.card) || (this.state.coupon != undefined && !this.state.coupon_valid)}
                        onClick={this.submit.bind(this)}
                        className={classes.button}>
                        {this.state.upgrading ? strings.upgrade : strings.checkout_subscribe}
                    </Button>
                </div>
            </React.Fragment >
        )
    }
}

const styles = (theme: Theme) => createStyles({
    listItem: {
        padding: `${theme.spacing()}px 0`,
    },
    total: {
        fontWeight: 700,
    },
    title: {
        marginTop: theme.spacing(2),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(),
    },
    formControl: {
        margin: theme.spacing(),
        minWidth: 120,
    },
    cancel_button: {
        marginLeft: 0,
        marginRight: 'auto'
    },
    inline: {
        display: 'inline',
    }
});

export default (withRouter((withUser(withToast(withStyles(styles)(Review)), true) as any)) as unknown as any)


// WEBPACK FOOTER //
// ./src/components/Checkout/Review.tsx